import { render, staticRenderFns } from "./ConfirmBuyList.vue?vue&type=template&id=2e16b1ff&scoped=true"
import script from "./ConfirmBuyList.vue?vue&type=script&lang=js"
export * from "./ConfirmBuyList.vue?vue&type=script&lang=js"
import style0 from "./ConfirmBuyList.vue?vue&type=style&index=0&id=2e16b1ff&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2e16b1ff",
  null
  
)

export default component.exports